import { useMutation } from "@tanstack/react-query";

import { orpc } from "@/client";
import type { SendResult } from "@/types/draft";

export function useSendMessage(callbacks?: {
	onSuccess?: (result: SendResult) => void;
	onSettled?: () => void;
}) {
	return useMutation(orpc.send.message.mutationOptions(callbacks));
}
